import { useStore } from '@/store/index'
import { useMemoizedFn } from 'ahooks'
import useLangPrefix from '../useLangPrefix'
import { HOME_PAGE_URL } from '@/constants/index'
import { useRouter } from 'next/router'
import { StoreProps } from '@/store/baseStore'

export interface HistoryRouterProps {
  type: 'price' | 'title' | 'type'
  tab: HOME_PAGE_URL
}

const useHistoryRouter = () => {
  const { locale } = useRouter()
  const { langPrefix } = useLangPrefix()

  const { setPageType, setTypeTab, tableRef, setPriceTab } = useStore().baseStore

  const changePageType = useMemoizedFn((url: HOME_PAGE_URL) => {
    window.history.pushState(null, '', `${langPrefix}${url}`)
    setPageType(url)
  })

  // todo tab 切换改变table数据
  const onChangeTab = useMemoizedFn((homePageUrl, tab?: string) => {
    tableRef?.fetchData(
      tab
        ? {
            page: 1,
            pageSize: 20,
            category_id: tab,
          }
        : { page: 1, pageSize: 20 },
      homePageUrl,
      locale
    )
  })

  const historyRouter = useMemoizedFn(({ type, tab }: HistoryRouterProps) => {
    if (type === 'price') {
      if (tab !== HOME_PAGE_URL.Others) {
        setTypeTab('all')
        setPriceTab(tab as StoreProps['priceTab'])

        if (Object.values(HOME_PAGE_URL).includes(tab)) {
          onChangeTab(tab)
          changePageType(tab)
        } else {
          onChangeTab(HOME_PAGE_URL.Others, tab)
          changePageType(`/price/view/${tab}` as HOME_PAGE_URL)
        }
      }
    }
  })

  return { historyRouter }
}

export default useHistoryRouter
